import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  Inject,
  Input,
  NgModule,
  OnDestroy,
} from '@angular/core';
import { WINDOW } from '@wizbii/angular-utilities';
import { fadeInOnEnterAnimation, fadeOutOnLeaveAnimation } from 'angular-animations';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-text-tooltip',
  templateUrl: './text-tooltip.component.html',
  styleUrls: ['./text-tooltip.component.scss'],
  animations: [fadeInOnEnterAnimation({ duration: 200 }), fadeOutOnLeaveAnimation({ duration: 200 })],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextTooltipComponent implements OnDestroy {
  private static Counter = 0;

  @Input() isLargeContentIntoModal = false;
  showTooltip$ = new BehaviorSubject<boolean>(false);
  timeout: any;

  readonly id = `app-tooltip-${++TextTooltipComponent.Counter}`;

  constructor(private readonly elmtRef: ElementRef, @Inject(WINDOW) private readonly window: any) {}

  @HostListener('document:click', ['$event.target'])
  doRegister(target: any): void {
    if (!this.elmtRef.nativeElement.contains(target)) {
      this.hideTooltip();
    }
  }

  click(): void {
    if (this.showTooltip$.value) {
      this.hideTooltip();
      return;
    }
    this.showTooltip();
  }

  showTooltip(): void {
    if (this.timeout) {
      this.window.clearInterval(this.timeout);
    }

    this.showTooltip$.next(true);
  }

  hideTooltip(): void {
    this.timeout = this.window.setTimeout(() => {
      this.showTooltip$.next(false);
    }, 300);
  }

  ngOnDestroy(): void {
    this.showTooltip$.complete();
  }
}

@NgModule({
  imports: [CommonModule],
  declarations: [TextTooltipComponent],
  exports: [TextTooltipComponent],
})
export class TextTooltipModule {}
